import React from 'react';
import ReactSVG from 'react-svg';
import store from 'root/site/store';

// Элемент иконки с теством
export const ElementItem = ({ text, icon, textColor, link, className, end, center, small, medium, big, fill, bigIcon, top, textOnly = false }) => {
	const handleClick = () => {
		link && store.history.push(link);
	};

	const classNamesWrapper = [
		'element-item',
		className,
		fill && `element-item__fill-${fill}`,
		end && 'element-item-end',
		center && 'element-item-center',
	]
		.filter(Boolean)
		.join(' ');

	const classNamesText = [
		'element-item-text',
		small && 'element-item-text-small',
		medium && 'element-item-text-medium',
		big && 'element-item-text-big',
	]
		.filter(Boolean)
		.join(' ');

	return (
		<div className={classNamesWrapper} onClick={() => handleClick()}>
			{!textOnly && <ReactSVG className={`element-item-icon  ${bigIcon ? 'element-item-icon-big' : ''}`} style={{ top: top }} src={icon} />}
			<span className={classNamesText} style={{ color: textColor ? textColor : '' }}>
				{text}
			</span>
		</div>
	);
};
